<template>
  <Scroll :height="height">
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
      style="text-align:left"
    >
      <Divider orientation="left">维修信息</Divider>
      <FormItem label="报警序号">
        <Input disabled v-model="formValidate.errorNumber"></Input>
      </FormItem>
      <FormItem label="报警类型">
        <Input disabled v-model="formValidate.errorType" placeholder="请输入表读数"></Input>
      </FormItem>
      <FormItem label="维修内容">
        <Input
          v-model="formValidate.content"
          type="textarea"
          :autosize="{minRows: 2,maxRows: 5}"
          placeholder="请输入维修内容"
        ></Input>
      </FormItem>
      <FormItem label="维修结果">
        <Select v-model="formValidate.result" @on-change="changeSelection">
          <Option v-for="(value, key) in repairResultEnum" :value="value" :key="key">{{value}}</Option>
        </Select>
      </FormItem>
      <!--FormItem label="备注" prop="remark">
        <Input
          v-model="formValidate.remark"
          type="textarea"
          :autosize="{minRows: 2,maxRows: 5}"
          placeholder="请输入备注"
        ></Input>
      </FormItem-->
      <div v-if="this.formValidate.result == '正常维修更换'">
        <FormItem label="字轮数" prop="nowBase" v-if="isFlow">
          <Row span=24 type="flex" justify="start" align="middle">
            <Col span=21>
              <Input v-model="formValidate.nowBase" placeholder="请输入字轮数"></Input>
            </Col>
            <Col span=2 offset=1>
              <p>m³</p>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="剩余金额" prop="remainMoney" v-if="!isFlow">
          <Row span=24 type="flex" justify="start" align="middle">
            <Col span=21>
              <Input v-model="formValidate.remainMoney" placeholder="请输入剩余金额"></Input>
            </Col>
            <Col span=2 offset=1>
              <p>元</p>
            </Col>
          </Row>
        </FormItem>
        <Divider orientation="left">新设备信息</Divider>
        <FormItem label="设备编号" prop="newmeterId">
          <Row span="24">
            <Col span="11">
              <DatePicker type="date" format="yyMMdd" @on-change="setTime" placeholder="请选择出厂日期"></DatePicker>
            </Col>
            <Col span="12" offset="1">
              <Input
                v-model="formValidate.meterNo"
                @on-change="computeMeterId"
                placeholder="请输入设备序号"
              ></Input>
            </Col>
          </Row>
          <Row span="24" style="padding:5px 0px 0px 0px">
            <Col span="11">
              <Input v-model="formValidate.newmeterId" placeholder="自动生成设备编号"></Input>
            </Col>
            <Col span="12" offset="1">
              <Button long @click="wechatScan">扫描条形码</Button>
            </Col>
          </Row>
          <Row span="24" style="padding:5px 0px 0px 0px">
            <Col span="11">
              <Button type="primary" long @click="searchMeterImportInfo">检索表具信息</Button>
            </Col>
          </Row>
        </FormItem>
        <div v-show="canInstall">
          <FormItem label="通讯方式" prop="newcommType">
            <Select v-model="formValidate.newcommType" placeholder="请选择设备通讯方式">
              <Option v-for="item in commTypeEnum" :value="item" :key="item">{{item}}</Option>
            </Select>
          </FormItem>
          <FormItem
            v-if="formValidate.newcommType=='NB' || formValidate.newcommType=='NB(电信)'"
            label="串号"
            prop="newimei"
          >
            <Input v-model="formValidate.newimei" @on-blur="onBlurBase" placeholder="请输入串号"></Input>
          </FormItem>
          <FormItem
            v-if="formValidate.newcommType=='NB' || formValidate.newcommType=='NB(电信)'"
            label="卡号"
            prop="newcardNumber"
          >
            <Input v-model="formValidate.newcardNumber" @on-blur="onBlurBase" placeholder="请输入卡号"></Input>
          </FormItem>
          <FormItem label="表厂家" prop="newmanufactor">
            <Select v-model="formValidate.newmanufactor" placeholder="请选择设备厂家">
              <Option v-for="item in manufacturerEnum" :value="item" :key="item">{{item}}</Option>
            </Select>
          </FormItem>
          <FormItem label="表规格" prop="newspec">
            <Select v-model="formValidate.newspec" placeholder="请选择设备规格">
              <Option v-for="item in specificationsEnum" :value="item" :key="item">{{item}}</Option>
            </Select>
          </FormItem>
          <FormItem label="设备类型" prop="newmeterType">
            <Select v-model="formValidate.newmeterType" placeholder="请选择设备类型">
              <Option v-for="(value, key) in meterTypeEnum" :value="key" :key="value">{{value}}</Option>
            </Select>
            <p style="color: #ff9900;" v-if="formValidate.newmeterType != formValidate.oldmeterType">
              新安装设备的设备类型与原表不一致，<br>即将用原表设备类型覆盖新表的设备类型
            </p>
          </FormItem>
          <FormItem label="用气类型" prop="newgasType">
            <Select v-model="formValidate.newgasType" placeholder="请选择用气类型">
              <Option v-for="(value, key) in gasTypeEnum" :value="key" :key="value">{{value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="表底数（m³）" prop="newbase">
            <Input
              v-model="formValidate.newbase"
              type="number"
              @on-blur="onBlurBase"
              placeholder="请输入表底数"
            ></Input>
          </FormItem>

          <!--FormItem label="备注" prop="newremark">
            <Input
              v-model="formValidate.newremark"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 5}"
              placeholder="请输入备注"
            ></Input>
          </FormItem-->
        </div>
      </div>
    </Form>
  </Scroll>
</template>
<script>
export default {
  props: {
    item: {}
  },
  methods: {
    computeMeterId() {
      if (
        this.formValidate.timeStampModel != "" &&
        this.formValidate.meterNo != ""
      ) {
        this.formValidate.meterNo = this.formValidate.meterNo.replace(
          /[&\|\\\*^%$#@\-]/g,
          ""
        );

        // while (this.formValidate.meterNo.length < 8) {
        //   this.formValidate.meterNo = "0" + this.formValidate.meterNo;
        // }

        while (this.formValidate.meterNo.length > 8) {
          this.formValidate.meterNo = this.formValidate.meterNo.substring(1);
        }

        let temp = "";
        while (temp.length + this.formValidate.meterNo.length < 8) {
          temp = temp + "0";
        }

        this.formValidate.newmeterId =
          this.formValidate.timeStampModel + temp + this.formValidate.meterNo;
      }
    },
    searchMeterImportInfo() {
      this.formValidate.oldmeterId = this.$parent.selectedItemInfo.meterId;
      this.formValidate.oldmeterType = this.$parent.selectedItemInfo.meterType;
      this.formValidate.oldmeterTypePayType = this.meterTypePayTypeList[this.formValidate.oldmeterType];
      this.isFlow = !!(this.formValidate.oldmeterTypePayType.indexOf("流量") != -1);
      
      var that = this;
      that.isSpinShow = true;
      console.log(that);
      $.ajax({
        url: "/api/InfoImport/searchMeterImportInfo",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          meterId: that.formValidate.newmeterId,
          addressGoverningBody: that.$parent.selectedItemInfo.addressGoverningBody
        }),
        success: function(data) {
          console.log(data);
          if (data.errorCode != 0) {
            that.$Notice.info({
              title: "提示",
              desc: data.errorInfo
            });

            that.isSpinShow = false;
            return;
          }

          if (data.body) {
            that.formValidate.newcommType =
              String(data.body.meterCommunicationMode) == "ctnnb"
                ? "NB(电信)"
                : data.body.meterCommunicationMode == "nb"
                ? "NB"
                : "WIFI";
            that.formValidate.newimei = String(data.body.meterSerialNumber);
            that.formValidate.newmanufactor = String(data.body.meterManufacturer);
            that.formValidate.newspec = String(data.body.meterSpecifications);
            that.formValidate.newmeterType = String(data.body.meterType);
            that.formValidate.newgasType = String(data.body.meterGasType);
            that.formValidate.newbase = String(data.body.meterBaseNumber);
            // that.formValidate.newremark =
            //   String(data.body.meterRemark) == "null"
            //     ? ""
            //     : String(data.body.meterRemark);
            that.formValidate.newcardNumber = String(data.body.meterRegisterKey);

            that.canInstall = true;
            console.log(data.body);
          } else {
            that.$Notice.info({
              title: "提示",
              desc: "未检索到有效表具"
            });

            that.canInstall = false;
          }
        },
        error: function(textStatus) {
          that.isSpinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    },
    wechatScan() {
      var that = this;
      that.isSpinShow = true;
      var thisUrl = encodeURIComponent(location.href);
      $.ajax({
        url: "/api/getJsapiConfig?thisUrl=" + thisUrl,
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.body == null) {
            return;
          }
          wx.config({
            debug: false, // 开启调试模式，关闭
            appId: receiveData.body.appId, // 必填，公众号的唯一标识
            timestamp: receiveData.body.timestamp, // 必填，生成签名的时间戳
            nonceStr: receiveData.body.nonceStr, // 必填，生成签名的随机串
            signature: receiveData.body.signature, // 必填，签名
            jsApiList: ["scanQRCode"] // 需要使用的jsapi列表
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ["scanQRCode"],
              success: function(res) {
                wx.scanQRCode({
                  needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                  scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                  success: function(res) {
                    var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                    if (result.indexOf("CODE_128") != -1) {
                      that.formValidate.meterId = result.split(",")[1];
                      //that.meterId = result.split(",")[1];
                    } else {
                      that.$Notice.error({
                        title: "异常",
                        desc: "请使用code_128条码！"
                      });
                    }
                  }
                });
              }
            });
          });
          console.log(receiveData);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    },
    setTime(e) {
      this.formValidate.timeStampModel = e;
      this.computeMeterId();
    },
    onBlurBase() {
      this.formValidate.newbase = parseFloat(this.formValidate.newbase).toFixed(
        3
      );
    },
    changeSelection(value) {
      if (value == "正常维修更换") {
      }
    },
    getFormItems() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.validatResult = true;
        } else {
          this.$Notice.warning({
            title: "提示",
            desc: "请完善安检信息"
          });
          this.validatResult = false;
        }
      });

      if (this.validatResult) {
        return this.formValidate;
      } else {
        return null;
      }
    }
  },
  mounted() {
  },
  created() {
    this.formValidate.errorNumber = JSON.parse(
      this.item.commandContent
    ).service.data.errorNumber;
    this.formValidate.errorType = this.errorEnum[
      JSON.parse(this.item.commandContent).service.data.errorNumber
    ].name;
  },
  data() {
    const validateNowBase = (rule, value, callback) => {
      var r = /^[0-9]+(.[0-9]{3})?$/;
      var flag = r.test(value);
        if (this.isFlow && !flag) {
            callback(new Error('请输入正确的字轮数(3位小数)...'));
        } else {
            callback();
        }
    };
    const validateRemainMoney = (rule, value, callback) => {
      var r = /^(\d+)(\.\d+)?$/;
      var flag = r.test(value);
        if (!this.isFlow && !flag) {
            callback(new Error('请输入正确格式的金额...'));
        } else {
            callback();
        }
    };
    return {
      isSpinShow: false,
      isFlow: true,
      canInstall: false,
      errorEnum: global.errorMsgParam,
      gasTypeEnum: global.gasType,
      validatResult: true,
      repairResultEnum: global.repairResult,
      checkItem: global.checkItem,
      height: document.body.clientHeight * 0.7,
      commTypeEnum: global.communicateType,
      meterTypeEnum: global.meterType,
      manufacturerEnum: global.manufacturer,
      specificationsEnum: global.specifications,
      meterTypePayTypeList: global.meterTypePayType,
      formValidate: {
        result: "正常维修",
        errorNumber: "",
        errorType: "",
        newcommType: "",
        newmanufactor: "",
        newspec: "",
        newmeterType: "",
        newgasType: "",
        newmeterId: "",
        newbase: "",
        // newremark: "",
        newimei: "",
        mewcardNumber: "",
        item: this.item,
        meterNo: "",
        nowBase: "",
        remainMoney: "",
        oldmeterType: "",
        oldmeterTypePayType: "",
        oldmeterId: ""
      },
      ruleValidate: {
        nowBase: [
          {
            required: true,
            validator: validateNowBase,
            trigger: "change"
          }
        ],
        remainMoney: [
          {
            required: true,
            validator: validateRemainMoney,
            trigger: "change"
          }
        ],
        newcommType: [
          {
            required: true,
            message: "请选择通讯方式",
            trigger: "blur"
          }
        ],
        newmanufactor: [
          {
            required: true,
            message: "请选择表厂家",
            trigger: "blur"
          }
        ],
        newspec: [
          {
            required: true,
            message: "请选择表具规格",
            trigger: "blur"
          }
        ],
        newgasType: [
          {
            required: true,
            message: "请选择用气类型",
            trigger: "blur"
          }
        ],
        newmeterType: [
          { required: true, message: "请选择设备类型", trigger: "blur" }
        ],
        newmeterId: [
          {
            required: true,
            message: "请输入设备编号",
            trigger: "change"
          }
          // ,
          // {
          //   type: "number",
          //   message: "请输入正确的设备编号，长度为14",
          //   trigger: "change"
          // }
        ],
        newbase: [
          {
            required: true,
            message: "请输入表底数",
            trigger: "change"
          }
          // ,
          // {
          //   type: "number",
          //   message: "请输入正确的表底数",
          //   trigger: "change"
          // }
        ],
        newspec: [
          {
            required: true,
            message: "请选择表具规格",
            trigger: "blur"
          }
        ],
        newbase: [
          {
            required: true,
            message: "请输入表底数",
            trigger: "blur"
          }
        ],
        newread: [
          {
            required: true,
            message: "请输入表读数",
            trigger: "blur"
          }
        ],
        newimei: [
          {
            required: true,
            message: "请输入串号",
            trigger: "blur"
          }
        ],
        newcardNumber: [
          {
            required: true,
            message: "请输入卡号",
            trigger: "blur"
          }
        ]
      }
    };
  }
};
</script>
